// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance-qr-overlay {
  --aq-ink: #1f1b2e;
  --aq-muted: #55515f;
  --aq-soft: #6f7588;
  --aq-lavender: #d5d1fd;
  --aq-panel: #f4f2f8;
  --aq-surface: #ffffff;
  --aq-line: rgba(31, 27, 46, 0.1);
  --aq-radius: 20px;

  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.attendance-qr-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 440px);
  max-height: min(90vh, 680px);
  margin: auto;
  background: var(--aq-surface);
  color: var(--aq-ink);
  border: 1px solid var(--aq-line);
  border-radius: var(--aq-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);
  overflow: hidden;
}

.attendance-qr-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.2rem 1.35rem 1rem;
  border-bottom: 1px solid var(--aq-line);
  background: var(--aq-surface);
}

.attendance-qr-dialog__header-text {
  min-width: 0;
}

.attendance-qr-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5a5580;
}

.attendance-qr-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.2rem, 2.4vw, 1.45rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--aq-ink);
  word-break: break-word;
}

.attendance-qr-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: #f4f4f6;
  color: var(--aq-ink);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.attendance-qr-dialog__close:hover {
  background: #ebebef;
  transform: translateY(-1px);
}

.attendance-qr-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1.15rem 1.35rem 1.35rem;
  -webkit-overflow-scrolling: touch;
}

.attendance-qr-dialog__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  padding: 1.15rem 1rem 1rem;
  background: var(--aq-panel);
  border: 1px solid var(--aq-line);
  border-radius: 14px;
  text-align: center;
}

.attendance-qr-dialog__code {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.85rem;
  background: var(--aq-surface);
  border: 1px solid var(--aq-line);
  border-radius: 12px;
}

.attendance-qr-dialog__code svg {
  display: block;
  width: min(220px, 62vw);
  height: auto;
}

.attendance-qr-dialog__course-label {
  margin: 0.15rem 0 0;
  max-width: 100%;
  font-family: "Merriweather", Georgia, serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--aq-ink);
  word-break: break-word;
}

.attendance-qr-dialog__meta {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--aq-soft);
}

.attendance-qr-dialog__actions {
  display: flex;
  justify-content: stretch;
  margin-top: 1.15rem;
}

.attendance-qr-dialog__done {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2.7rem;
  padding: 0.65rem 1rem;
  border: 1px solid rgba(120, 110, 180, 0.35);
  border-radius: 10px;
  background: var(--aq-lavender);
  color: #403b55;
  font-weight: 750;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.attendance-qr-dialog__done:hover {
  background: #d5d1fd;
  transform: translateY(-1px);
}

.attendance-qr-dialog__done:focus-visible,
.attendance-qr-dialog__close:focus-visible {
  outline: 2px solid #8b84c7;
  outline-offset: 2px;
}

@media (max-width: 480px) {
  .attendance-qr-overlay {
    padding: 1rem;
  }

  .attendance-qr-dialog__header,
  .attendance-qr-dialog__body {
    padding-left: 1.1rem;
    padding-right: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AttendanceQrDialog.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;AACF","sourcesContent":[".attendance-qr-overlay {\n  --aq-ink: #1f1b2e;\n  --aq-muted: #55515f;\n  --aq-soft: #6f7588;\n  --aq-lavender: #d5d1fd;\n  --aq-panel: #f4f2f8;\n  --aq-surface: #ffffff;\n  --aq-line: rgba(31, 27, 46, 0.1);\n  --aq-radius: 20px;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.52);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.attendance-qr-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 440px);\n  max-height: min(90vh, 680px);\n  margin: auto;\n  background: var(--aq-surface);\n  color: var(--aq-ink);\n  border: 1px solid var(--aq-line);\n  border-radius: var(--aq-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);\n  overflow: hidden;\n}\n\n.attendance-qr-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1.2rem 1.35rem 1rem;\n  border-bottom: 1px solid var(--aq-line);\n  background: var(--aq-surface);\n}\n\n.attendance-qr-dialog__header-text {\n  min-width: 0;\n}\n\n.attendance-qr-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5a5580;\n}\n\n.attendance-qr-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.2rem, 2.4vw, 1.45rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--aq-ink);\n  word-break: break-word;\n}\n\n.attendance-qr-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: #f4f4f6;\n  color: var(--aq-ink);\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.attendance-qr-dialog__close:hover {\n  background: #ebebef;\n  transform: translateY(-1px);\n}\n\n.attendance-qr-dialog__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 1.15rem 1.35rem 1.35rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.attendance-qr-dialog__card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 1.15rem 1rem 1rem;\n  background: var(--aq-panel);\n  border: 1px solid var(--aq-line);\n  border-radius: 14px;\n  text-align: center;\n}\n\n.attendance-qr-dialog__code {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.85rem;\n  background: var(--aq-surface);\n  border: 1px solid var(--aq-line);\n  border-radius: 12px;\n}\n\n.attendance-qr-dialog__code svg {\n  display: block;\n  width: min(220px, 62vw);\n  height: auto;\n}\n\n.attendance-qr-dialog__course-label {\n  margin: 0.15rem 0 0;\n  max-width: 100%;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--aq-ink);\n  word-break: break-word;\n}\n\n.attendance-qr-dialog__meta {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--aq-soft);\n}\n\n.attendance-qr-dialog__actions {\n  display: flex;\n  justify-content: stretch;\n  margin-top: 1.15rem;\n}\n\n.attendance-qr-dialog__done {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 2.7rem;\n  padding: 0.65rem 1rem;\n  border: 1px solid rgba(120, 110, 180, 0.35);\n  border-radius: 10px;\n  background: var(--aq-lavender);\n  color: #403b55;\n  font-weight: 750;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.attendance-qr-dialog__done:hover {\n  background: #d5d1fd;\n  transform: translateY(-1px);\n}\n\n.attendance-qr-dialog__done:focus-visible,\n.attendance-qr-dialog__close:focus-visible {\n  outline: 2px solid #8b84c7;\n  outline-offset: 2px;\n}\n\n@media (max-width: 480px) {\n  .attendance-qr-overlay {\n    padding: 1rem;\n  }\n\n  .attendance-qr-dialog__header,\n  .attendance-qr-dialog__body {\n    padding-left: 1.1rem;\n    padding-right: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
